import api from './client'

export async function getSettings() {
  const { data } = await api.get('/users/settings')
  return data
}

export async function saveSettings(settings: Record<string, unknown>) {
  const { data } = await api.post('/users/settings', settings)
  return data
}

export async function getRole() {
  const { data } = await api.get('/users/role')
  return data
}

export async function changePassword(currentPassword: string, newPassword: string, confirmPassword: string) {
  const { data } = await api.post('/users/change-password', {
    current_password: currentPassword,
    new_password: newPassword,
    confirm_password: confirmPassword,
  })
  return data
}

export async function updateShortUserId(shortUserId: string) {
  const { data } = await api.post('/users/short-user-id', {
    short_user_id: shortUserId,
  })
  return data as { short_user_id: string; effective_short_user_id: string }
}

/* ── Two-factor sign-in (Settings → Account) ─────────────────────────── */

export interface MfaStatus {
  enrolled: boolean
  enrolled_at: string | null
  recovery_codes_remaining: number
  policy: { mode: 'off' | 'optional' | 'required'; grace_days: number }
  /** False while the organization requires two-factor sign-in. */
  can_disable: boolean
  /** Set when MFA is required and not yet set up: the grace period's end. */
  enrol_by: string | null
}

export async function getMfaStatus() {
  const { data } = await api.get('/users/mfa')
  return data as MfaStatus
}

/** Replacing an existing authenticator needs the password + a current code. */
export async function startTotpSetup(confirm?: { password: string; code: string }) {
  const { data } = await api.post('/users/mfa/totp/start', confirm || {})
  return data as { secret: string; otpauth_uri: string; qr_svg?: string | null; account?: string }
}

export async function confirmTotpSetup(code: string) {
  const { data } = await api.post('/users/mfa/totp/confirm', { code })
  return data as MfaStatus & { recovery_codes: string[] }
}

/** Needs the password AND a current code. */
export async function regenerateRecoveryCodes(password: string, code: string) {
  const { data } = await api.post('/users/mfa/recovery-codes', { password, code })
  return data as { recovery_codes: string[] }
}

export async function disableMfa(password: string, code: string) {
  const { data } = await api.post('/users/mfa/disable', { password, code })
  return data as MfaStatus
}
